package top.wcpe.allincore.ui.runtime.element

import kotlin.jvm.JvmStatic

/**
 * 字体样式声明：namespaced 名字 + 渲染属性。
 *
 * 三层（元素 / 页面 / 全局）按字段 merge，null 字段表示「继承上层」。
 */
class FontStyle private constructor(
    private val nameValue: String?,
    private val shadowValue: Boolean?,
    private val boldValue: Boolean?,
    private val italicValue: Boolean?,
) {

    // -------- getter（保留 Java 方法式访问器 ABI） --------

    fun name(): String? = nameValue

    fun shadow(): Boolean? = shadowValue

    fun bold(): Boolean? = boldValue

    fun italic(): Boolean? = italicValue

    // -------- merge --------

    /**
     * 按字段合并：当前实例的非 null 字段优先，null 字段从 parent 取。返回新实例，不修改 this 或 parent。
     */
    fun merge(parent: FontStyle?): FontStyle = if (parent == null) {
        this
    } else {
        FontStyle(
            nameValue ?: parent.nameValue,
            shadowValue ?: parent.shadowValue,
            boldValue ?: parent.boldValue,
            italicValue ?: parent.italicValue,
        )
    }

    // -------- effective（最终值，null 时给默认） --------

    fun effectiveName(): String = nameValue ?: DEFAULT_NAME

    fun effectiveShadow(): Boolean = shadowValue == true

    fun effectiveBold(): Boolean = boldValue == true

    fun effectiveItalic(): Boolean = italicValue == true

    /** FontStyle 构建器。 */
    class Builder internal constructor() {
        private var nameValue: String? = null
        private var shadowValue: Boolean? = null
        private var boldValue: Boolean? = null
        private var italicValue: Boolean? = null

        fun name(name: String?): Builder = apply { nameValue = name }

        fun shadow(shadow: Boolean?): Builder = apply { shadowValue = shadow }

        fun bold(bold: Boolean?): Builder = apply { boldValue = bold }

        fun italic(italic: Boolean?): Builder = apply { italicValue = italic }

        fun build(): FontStyle = FontStyle(nameValue, shadowValue, boldValue, italicValue)
    }

    companion object {
        /** 默认字体名。 */
        const val DEFAULT_NAME = "minecraft:default"

        /** 创建仅指定字体名的实例。 */
        @JvmStatic
        fun of(name: String?): FontStyle = FontStyle(name, null, null, null)

        /** 创建空实例（所有字段为 null，表示完全继承上层）。 */
        @JvmStatic
        fun empty(): FontStyle = FontStyle(null, null, null, null)

        /** 创建 builder。 */
        @JvmStatic
        fun builder(): Builder = Builder()
    }
}
